/* eslint-disable no-empty-pattern */
import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '@/_services/encryption';
const state = {
    getCards: [],
    getCardDetails:[],
    blockCardReason:[],
    availableAccounts:[],
};
const mutations = {
    // set user budget
    SET_USER_CARDS(state, payload) {
        state.getCards = payload;
    },
    // set user card details
    SET_USER_CARD_DETAILS(state, payload) {
        state.getCardDetails = payload;
    },
    // set block card reason
    SET_BLOCK_CARD_REASON(state, payload) {
        state.blockCardReason = payload;
    },
    // set available accounts
    SET_AVAILABLE_ACCOUNTS(state, payload) {
        state.availableAccounts = payload;
    }
};
const actions = {
    // get user cards
    async getUserCards({ commit }, data) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Cards/GetCards`, data, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_USER_CARDS', userParseData);
            }
            return response;
        }
    },
    async getNewUserCards({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Cards/GetCards`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_USER_CARDS', userParseData);
            }
            return response;
        }
    },
    // get user card details
    async getUserCardDetails({ commit }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Cards/GetCardDetails`, encryptedData, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_USER_CARD_DETAILS', userParseData);
            }
            return response;
        }
    },
    // get block card reason
    async getBlockCardReason({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Enum/getCardBlockReason`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_BLOCK_CARD_REASON', userParseData);
            }
            return response;
        }
    },
    // block card 
    async blockUserCard({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Cards/BlockCard`, encryptedData, { headers });
            if (response.status === 200) {
                return response;
            }
        }
    },
    // hotlist card
    async hotlistUserCard({ }, data) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Cards/HotlistCard`, data, { headers });
            if (response.status === 200) {
                return response;
            }
        }
    },
    // pin retrieval
    async retrieveUserPin({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Cards/CardPinRetrieval`, encryptedData, { headers });
            if (response.status === 200) {
                return response;
            }
        }
    },
    // unblock card
    async unblockUserCard({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Cards/UnblockCard`, encryptedData, { headers });
            if (response.status === 200) {
                return response;
            }
        }
    },
    // get available accounts
    async getAvailableAccounts({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Cards/GetAvailableAccounts`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_AVAILABLE_ACCOUNTS', userParseData);
            }
            return response;
        }
    }
};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};